import { createFileRoute } from "@tanstack/react-router";
import { EmployerSaintThankYou } from "@/pages/employer-saint/EmployerSaintThankYou";
import { americanAirlines } from "@/pages/employer-saint/employers";
export const Route = createFileRoute("/thank-you/american-airlines-saint")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Thank You — AA SAINT® | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Thank you for your interest in SAINT® TMS for American Airlines employees. Our Coral Springs, FL team will contact you about your 5-day depression treatment.",
        },
        {
          property: "og:title",
          content: "Thank You — AA SAINT® | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Thank you for your interest in SAINT® TMS for American Airlines employees. Our Coral Springs, FL team will contact you about your 5-day depression treatment.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/thank-you/american-airlines-saint",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you/american-airlines-saint",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <EmployerSaintThankYou employer={americanAirlines} />;
}
